<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div [formGroup]="dataForm">
	<div class="flex-layout-row flex-layout-align-start-center flex-layout-gap-20px">
		<div class="date">
			<!-- <span *ngIf="showValidationMessage"> E:{{validationMessage}} </span> -->
			<!-- <span *ngIf="!showValidationMessage"> V </span> -->
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>{{ label }}</mat-label>
				<!-- blur and dateChange mark the control as touched,
         (blur) works if the user clicks in and out of the input without entering a value
         (dateChange) works if the user selects a date using the datepicker-->
				<input formControlName="date" matInput [matDatepicker]="dpDateFrom" (blur)="handleExit()" (dateInput)="markAsTouched()" />
				<mat-datepicker-toggle matSuffix [for]="dpDateFrom"></mat-datepicker-toggle>
				<!-- closed marks the input as touched if the user opens and closes the date picker without seecting a value -->
				<mat-datepicker #dpDateFrom (closed)="handleExit()"></mat-datepicker>
			</mat-form-field>
		</div>

		<div class="time">
			<mat-form-field subscriptSizing="dynamic">
				<!-- blur and input mark the control as touched,
         (blur) works if the user clicks in and out of the input without entering a value
         (dateChange) works if the user clicks in and out of the input using the timepicker-->
				<input formControlName="time" matInput type="time" (blur)="markAsTouched()" (input)="markAsTouched()" />
			</mat-form-field>
		</div>
	</div>
</div>
